import { render } from "./Income.vue?vue&type=template&id=04020370&scoped=true"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"

import "./Income.vue?vue&type=style&index=0&id=04020370&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-04020370"

export default script